export default "__VITE_ASSET__ats2yX81__"